module.exports = __webpack_public_path__ + "assets/img/大会标题.4a9e859b.png";